import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'InfoBlock',
  props: {
  loadingError: String,
  text: String,
  text2: String,
  color: String,
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ color: __props.color })
  }, [
    _createElementVNode("h2", null, _toDisplayString(props.text || "Произошла ошибка"), 1),
    _createElementVNode("h3", null, _toDisplayString(props.text2), 1),
    _createElementVNode("h3", null, _toDisplayString(props.loadingError), 1)
  ], 4))
}
}

})